import {
  type DateRange,
  type GuestsSelection,
  HotelStarRating,
  type Suggestion,
  type Amenity,
  type Lodging,
  type LodgingSelectionEnum,
  type MealPlanKind,
  type StayType,
  type LodgingHomesAmenityKind,
  type LodgingSelection,
} from "@b2bportal/lodging-api";

// Define a type for search details
export type SearchData = {
  dateRange: DateRange;
  guests: GuestsSelection;
  rooms: number;
};
export type SearchDetails = SearchData & {
  place: Suggestion;
  searchType: LodgingSelectionEnum;

  // Optional for backwards compatibility upgrade until we deprecate place | searchType
  // Null to make this field explicit.
  lodgingSelection: LodgingSelection | null;
};

export interface PriceRange {
  min: number;
  max: number;
}

export interface HomeRoomsAndBeds {
  numberOfBathrooms?: number;
  numberOfBedrooms?: number;
  numberOfBeds?: number;
}

export interface FilterState {
  priceRange: PriceRange;
  starRating: HotelStarRating[];
  freeCancellation: boolean;
  payLater: boolean;
  amenities: Amenity[];
  hotelName?: string;
  mealPlan: MealPlanKind[];
  stayType: StayType[];
  homeAmenities: LodgingHomesAmenityKind[];
  homeRoomsAndBeds?: HomeRoomsAndBeds;
  userRating?: number;
}

export interface FilterOptions {
  priceRange: PriceRange;
  amenities: Amenity[];
  homeAmenities: LodgingHomesAmenityKind[];
}

export type AvailableHotelStarRatingValue = 1 | 2 | 3 | 4 | 5;

export type StarRatingValue = AvailableHotelStarRatingValue | undefined;

export const HotelStarRatingWithoutNotAvailable = (({
  NotAvailable,
  ...rest
}) => rest)(HotelStarRating);

export type AvailableHotelStarRating = Omit<
  typeof HotelStarRating,
  "NotAvailable"
>;

export enum HotelSortOptionEnum {
  Recommended = "recommended",
  StarRating = "starRating",
  UserRating = "userRating",
  Price = "price",
}

export type HotelComparator = (a: Lodging, b: Lodging) => number;
